export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        className: 'nav-links'
    },

    {
        title: 'About',
        url: '/about',
        className: 'nav-links'
    },

    {
        title: 'Projects',
        url: '/projects',
        className: 'nav-links'
    },

    {
        title: 'Resume',
        url: '/resume',
        className: 'nav-links'
    }

    // {
    //     title: 'Contact',
    //     url: '/contact',
    //     className: 'nav-links'
    // }
]